import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { authGuard } from './utils/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./modules/home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'about',
    loadComponent: () => import('./components/pages/about-us/about-us.component').then((m) => m.AboutUsComponent),
  },
  {
    path: 'term-of-services',
    loadComponent: () =>
      import('./components/pages/terms-of-service/terms-of-service.component').then((m) => m.TermsOfServiceComponent),
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./components/pages/privacy-policy/privacy-policy.component').then((m) => m.PrivacyPolicyComponent),
  },
  {
    path: 'invest-with-us',
    loadComponent: () =>
      import('./components/pages/invest-with-us/invest-with-us.component').then((m) => m.InvestWithUsComponent),
  },
  {
    path: 'how-it-works',
    loadComponent: () =>
      import('./components/pages/how-it-works-page/how-it-works-page.component').then((m) => m.HowItWorksPageComponent),
  },
  {
    path: 'checkout',
    loadChildren: () => import('./modules/checkout/checkout.module').then((m) => m.CheckoutModule),
  },
  {
    path: 'profile',
    loadChildren: () => import('./modules/profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: 'rentals',
    loadChildren: () => import('./modules/listings/listings.module').then((m) => m.ListingsModule),
  },
  {
    path: 'blog',
    loadChildren: () => import('./modules/blog-detail/blog-detail.module').then((m) => m.BlogDetailModule),
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadChildren: () => import('./modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  {
    path: 'stripe-success',
    loadComponent: () =>
      import('./components/common/stripe-success/stripe-success.component').then((m) => m.StripeSuccessComponent),
  },
  {
    path: 'stripe-cancel',
    loadComponent: () =>
      import('./components/common/stripe-cancel/stripe-cancel.component').then((m) => m.StripeCancelComponent),
  },
  {
    path: 'paypal-success',
    loadComponent: () =>
      import('./components/common/paypal-success/paypal-success.component').then((m) => m.PaypalSuccessComponent),
  },
  {
    path: 'paypal-cancel',
    loadComponent: () =>
      import('./components/common/paypal-cancel/paypal-cancel.component').then((m) => m.PaypalCancelComponent),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./components/pages/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
  },
  {
    path: 'delete-account',
    loadComponent: () =>
      import('./components/pages/delete-account/delete-account.component').then((m) => m.DeleteAccountComponent),
  },
  {
    path: 'career-and-investors',
    loadComponent: () =>
      import('./components/pages/career-and-investors/career-and-investors.component').then(
        (m) => m.CareerAndInvestorsComponent,
      ),
  },
  {
    path: 'blogs',
    loadChildren: () => import('./modules/blogs/blogs.module').then((m) => m.BlogsModule),
  },
  {
    path: 'host-onboarding',
    loadComponent: () =>
      import('./components/common/host-onboaring/host-onboaring.component').then((m) => m.HostOnboaringComponent),
  },
  {
    path: '**',
    loadComponent: () => import('./components/pages/not-found/not-found.component').then((m) => m.NotFoundComponent),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      preloadingStrategy: PreloadAllModules,
      initialNavigation: 'enabledBlocking',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
